<script setup lang="ts">
// Use centralized tracking composable
const { trackPageView } = useTracking();

// Track pageview events on SPA navigation
useScriptEventPage(({ title, path }) => {
    void trackPageView(title, path);
});
</script>
<template>
    <div class="bg-gradient-to-br from-blue-500 to-blue-900 bg-no-repeat" style="background-size: 100% 800px">
        <MainMenu />
        <slot />
        <Footer />
    </div>
</template>
